<div class="meta-content-wrapper">
  @if (legendState.metadata && legendState.metadata.length > 0) {
    <div>
      @for (data of legendState.metadata; track data) {
        <div class="meta-content">
          <div class="commonName mt-2 d-flex justify-content-between" (click)="toggleMetaContent(data.commonName)">
            <div class="dataName">{{ data.commonName}}</div>
            <div class="dataName-toggle">
              <button type="button" class="btn btn-link" [class.up]="metaExpand === data.commonName">
                <span class="far fa-chevron-down"></span>
              </button>
            </div>
          </div>
          @if (metaExpand === data.commonName) {
            <div class="meta-details mx-2 p-1">
              <div class="section-title">General</div>
              <div class="section-subtitle">Description</div>
              {{data.description}}
              <div class="section-subtitle">Coverage</div>
              {{data.coverage}}
              <div class="section-subtitle">Data Owner</div>
              {{data.dataOwner}}
              <div class="section-title">Layer History</div>
              @if (data.history1Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history1Date}}</div>
                  {{data.history1}}
                </div>
              }
              @if (data.history2Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history2Date}}</div>
                  {{data.history2}}
                </div>
              }
              @if (data.history3Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history3Date}}</div>
                  {{data.history3}}
                </div>
              }
              @if (data.history4Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history4Date}}</div>
                  {{data.history4}}
                </div>
              }
              @if (data.history5Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history5Date}}</div>
                  {{data.history5}}
                </div>
              }
              @if (data.history6Date !== null) {
                <div>
                  <div class="section-subtitle">{{data.history6Date}}</div>
                  {{data.history6}}
                </div>
              }
              <div class="section-title">Layer Maintenance</div>
              <div class="section-subtitle">Maintenance Type</div>
              {{data.maintenanceType}}
              <div class="section-subtitle">Manual Frequency</div>
              {{data.manualFrequency}}
              <div class="section-subtitle">Manual Source</div>
              {{data.manualSource}}
              <div class="section-subtitle">Maintenance Method</div>
              {{data.maintenanceMethod}}
              <div class="section-title">Other Information</div>
              @if (data.accuracyComments !== null) {
                <div>
                  <div class="section-subtitle">AccuracyComments</div>
                  {{data.accuracyComments}}
                </div>
              }
              @if (data.financialIdentifiers !== null) {
                <div>
                  <div class="section-subtitle">Financial Identifiers</div>
                  {{data.financialIdentifiers}}
                </div>
              }
              @if (data.personalIdentifiers !== null) {
                <div>
                  <div class="section-subtitle">Personal Identifiers</div>
                  {{data.personalIdentifiers}}
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="mt-3 ml-2">There is no meta data for this layer</div>
  }
</div>